<template>
  <div>
    <TerminalOperatorSelector
      :model="terminal_operator"
    />
    <template v-if="direction === 'In'">
      <GenericTextField
        :model="shipper"
        label="Shipper"
      />
    </template>
    <template v-if="direction === 'Out'">
      <GenericTextField
        :model="shipper"
        label="Consignee"
      />
    </template>
  </div>
</template>

<script>
import TerminalOperatorSelector from './TerminalOperatorSelector';

export default {
  name: 'AccessPermitRequestGatePass',
  components: {
    TerminalOperatorSelector,
  },
  data: () => ({
    terminal_operator: '',
    shipper: '',
  }),
};
</script>

<style scoped>

</style>
